// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Fonts/N27-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Fonts/N27-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/Images/noise_user.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: PP-Nuebit;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: N27;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: N27-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: N27-Regular-Italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: N27-Light-Italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@media only screen and (min-width: 900px) {
.user-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: 23% 82%;
  background-position-x: center;
  background-position-y: center;
}
.coursenav-bar-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height:3rem;
  padding: 1rem 4rem 1rem 4rem;
  border-bottom: 1pt solid #c9c9c9;
 
}
.coursepage-navigation-container{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 8rem;
}
.coursenav-button-container{
  display: flex;
  height: 100%;
  width:8rem;
  margin-right: 2.5rem;
}

.course-page-container {
  display: flex;
  /* border: 1px solid red; */
  padding: 4rem 4rem 0 4rem;
  width:92%;
}

.course-page-left-grid {
  max-width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-right: 2.9rem;
  margin-top: 1rem;
}
.user-box-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width:87%
}

.course-page-left-grid .box-1 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 5rem;
 
}
.box-1-heading{
  font-family: N27-Medium;
  font-weight: 500;
  font-size: 5.25rem;
  text-align: left;
  margin: 0;
}
.course-page-left-grid .box-2 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start; 
}

.team-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 2.5rem;
}
.box-2-text{
  font-family: N27;
  font-weight: 400;
  font-size: 1.25rem;
  text-align: left;
  margin: 0;
}
.countdown-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 4rem;
  width:98%;

}
.course-page-left-grid .progress-bar .progress-text {
  position: absolute;
  right: 0.5rem;
  font-size: 1.25rem;
  font-family: N27-Medium;
  color: black;
}
.course-page-left-grid .progress-bar .progress-para {
  position: absolute;
  right: 40%;
  font-family: N27;
  font-size: 1.25rem;
  color: black;
}

.course-page-right-grid {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 2.9rem;
}
.course-page-right-grid .profile-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 2.5rem;
  width:35.875rem;
  
}
.profile{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid rgb(0, 0, 0);
  margin-bottom: 0.75rem;
  width: 100%;

}

.course-page-right-grid .profile-container .profile .profile-video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 34.625rem;
}
.course-page-right-grid .profile-container .profile .profile-vid {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.profile-video-container .play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  cursor: pointer;
}

.timeline {
  height: 5px; 
  border-top-right-radius:5px;
  border-bottom-right-radius:5px;
  background-color: red; /* The color you want for the progress */
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
}

/* Customizing the video controls */
.profile-video-container .profile-vid::-webkit-media-controls-timeline {
  background-color: red;
}

.profile-video-container .profile-vid::-webkit-media-controls-play-button {
  display: none;
}

.profile-video-container .profile-vid::-webkit-media-controls {
  display: none;
}



.course-page-right-grid .profile-container .profile .logo {
  position: absolute;
  top: 0;
  left: 0;
}
.user-details-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1.5rem 0 1.5rem 1.5rem;
  width: 95%;
  

}

.course-page-right-grid .profile-container .name-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 1.875rem; 
}

.course-page-right-grid .profile-container .profile .name {
  font-family: PP-Nuebit;
  font-weight: 700;
  text-align: left;
  font-size: 3.5rem;
}

.course-page-right-grid .profile-container .box-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  
}
.deflix-contributor-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 5rem;
  width: 100%;
}
.course-page-right-grid .profile-container .box-1 .text {
  font-family: PP-Nuebit;
  font-weight: 400;
  font-size: 2.2rem;
  text-align: left;
  margin: 0;
}
.role-box-container{
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black; 
  height: 2.375rem;
  width: 18rem;
  background-color: #f5f5f5;
  
}
.course-page-right-grid .profile-container .profile .box-1 .box {
  font-family: N27;
  font-weight: 400;
  font-size: 1rem;
 
}
.statistic-value {
    border: 1px solid #c9c9c9;
    padding: 0.313rem;
    display: inline-block;
    margin: 0 0.3rem 1rem 0.31rem;
    min-width: 1.8rem;
    height: 1.5rem;
    text-align: center;
    font-family: N27-Medium;
}
.contribution{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.video-overlay {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7); 
  width: 87%;
  height: 89%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 2rem 2.6rem 2rem 2rem;
}

.overlay-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  
}
.overlay-header-container{
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-bottom: 1.2rem;
}
.overlay-header{
  font-family:N27-Regular-Italic;
  font-size: 2.25rem;
  text-align: left;
  color: white;
  margin: 0;
}
.overlay-desciption-container{
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-bottom: 2.5rem;
}
.play-btn-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.25rem;
  width: 100%; 
  height:6rem;
 
}
.play-btn{
  cursor: pointer;
}
.overlay-text {
  font-family: N27-Light-Italic; 
  line-height: 160%;
  font-size: 1rem;
  text-align: left;
  color: white;
  margin: 0;
}
.playbutton-description-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3.75rem;
  width:100%;
}
.playbutton-description{
  font-family: N27-Light-Italic; 
  line-height: 160%;
  font-size: 1rem;
  text-align: center;
  color: white;
  margin: 0;
}
.task-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border:1pt solid black;
  min-height:16.375rem;
  width:100%;
  
}
.task-header-container{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1pt solid black;
  height: 3.125rem;
  width: 94.5%;
  padding: 0 1.125rem;
}
.task-header{
  font-family: N27-Regular-Italic;
  font-size: 1.25rem;
  text-align: left;
  margin: 0;
}
.task-content-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  width: 94.5%;
  padding: 0 1.125rem;

}
.task-info-container{
  display: flex;
  height:6.313rem;
  justify-content: space-between;
  align-items:center;
  width: 100%;

}
.task-no-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.task-no{
  font-family:N27-Medium ;
  font-size: 4rem;
  text-align: left;
  color: black;
  margin: 0;
}
.goto-task-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height:3rem;
  width:11rem;
  cursor: pointer;
}
.course-level-info-outer-container{
  display: flex;
  width: 99.5%;
  padding: 0 0.1rem;
  justify-content: flex-start;
  align-items: center;
}
.vector-container{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  width:13.594rem;
  border-top: 1pt solid #9c9c9c;
}
.course-level-info-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 9.375rem;
  margin: 0 0.938rem;
  z-index: 100;

}
.task-course-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.task-course{
  font-family: N27;
  font-size: 1.25rem;
  text-align: left;
  margin: 0;
  min-width: 4rem;
}
.task-course-dot{
  font-family: N27;
  font-size: 1.25rem;
  text-align: left;
  margin: 0 0.2rem 0 0.2rem;
}
.task-level-container{
  display: flex;
  justify-content: center;
  align-items: center;
  height:1.5rem;
  min-width: 4.938rem;
  background-color: #15B525;
  margin-left: 0.2rem;
}
.task-level{
  font-family: N27;
  font-size: 0.8rem;
  color: white;
  margin: 0;
}
.task-status-info-outer-container{
  display: flex;
  width: 99.5%;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 1.25rem;
}

.task-status-info-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.task-name-time-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task-play-icon-container{
  height:1.5rem;
  width:1.5rem;
  margin-right: 0.5rem;
}
.task-name-container{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-right: 1.25rem;
  max-width: 20rem;
}
.task-name{
  font-family: N27-Light-Italic;
  font-size: 1.25rem;
  line-height: 150%;
  color: #3D3D3D;
  margin: 0;
  text-align: left;
}
.task-time-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task-description-container{
  display: flex;
  justify-content:flex-start;
  align-items:flex-start;
  padding:0 2rem;
  margin-top: 0.75rem;
}
.task-description{
  font-family: N27-Light-Italic;
  font-size: 1rem;
  line-height: 150%;
  color: #7B7B7B;
  text-align: left;
  margin: 0;
}
.task-status-icon-container{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height:2rem;
  width:7.5rem;
  margin: 0.5rem 0;
}
.coursepage-navigation-container{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 1.3% 3.6% 1% 35.4%;
  height: 3rem;
  width: 92.2%;
}
.nav-user-button-container{
  display: flex;
  justify-content: space-between;
  height: 65%;
  width:16.5rem;
 
}
.user-button{
  height: 2.3rem;
  width: 8.438rem;
  border: 0.5pt solid #c6c4c4;
  background-color: white;
  padding: 0.3rem 1rem 0.5rem 1rem;
  font-family:PP-Nuebit ;
  font-size: 1.35rem;
  color: black;
  text-align: center;
}
.logout-button{
  height: 2.3rem;
  width: 6.438rem;
  border: 0.5pt solid #c6c4c4;
  background-color: white;
  padding: 0.3rem 0.5rem 0.5rem 0.5rem;
  font-family:PP-Nuebit ;
  font-size: 1.35rem;
  color: black;
  text-align: center;
  cursor: pointer;
}
.course-spin-container {
  align-items: center;
  display: flex;
  height: 50rem;
  justify-content: center;
  width: 50rem;
}

.course-loading {
  animation: sk-scaleout 1.0s infinite ease-in-out;
  background-color: black;
  border-radius: 100%;
  height: 6em;
  width: 6em;
}
.pause-btn{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  cursor: pointer;
  height: 6rem;
  width: 6rem;
}

.profile-pause-video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 34.625rem;
}
}

@media only screen and (max-width: 900px) {
  .mobNavContainer{
    display: flex;
    width: 93.5%;
    height:3.375rem;
    padding:0.75rem 0.875rem 0.75rem 0.875rem;
    align-items: center;
    justify-items: center;
    background-color: #FFFFFF;
  }
  .mobNavBar{
    display: flex;
    width: 20.75rem;
    height: 1.875rem;
    align-items: center;
    justify-content: space-between;
  }
  .mobnavW3o{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width:8.5rem;
    height:1.5rem;
  }
  .mobhamburg{
    height: 1.4rem;
    width: 1.4rem;
    margin:0.1rem 0.438rem;
  }
  .mobw3onavContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    width:6.25rem;
    font-family: PP-Nuebit;
    font-size: 1.5rem;
    margin: 0 0 0.3rem 0.5rem;
    
  }

  .profile{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border: 1px solid rgb(0, 0, 0);
    margin-bottom: 0.75rem;
    width: 99.5%;
  }
  .profile-video-container {
    height: 13.5rem;
  }
  
  .video-overlay{
  width: 93%;
  padding: 0.5rem 1rem 0.5rem 1rem;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7); 
  }
  .overlay-header-container{
    margin-bottom: 0.5rem;
  }
  .overlay-header{
    font-size: 1.25rem;
    margin: 0;
    color: white;
  }
  .overlay-desciption-container{
    margin-bottom: 0.5rem;
  }
  .overlay-text {
    font-size: 0.75rem;
    margin: 0;
    color: white;
  }
  .play-btn-container{
    margin-bottom: 0.5rem;
    width: 100%; 
    height:3rem;
  }
  .play-btn {
    height:3rem;
    width: 3rem;
  }
  .playbutton-description-container{
    margin-bottom: 0.5rem;
    width:100%;
  }
  .playbutton-description{
    line-height: 115%;
    font-size: 0.75rem;
    margin: 0;
    color: white;
  }
  .profile-vid {
    width: 100%;
    height: 13.4rem;
    object-fit: cover;
  }
  
  .timeline {
    height: 5px; 
    border-top-right-radius:5px;
    border-bottom-right-radius:5px;
    background-color: red; /* The color you want for the progress */
    position: absolute;
    bottom: 0;
    left: 0;
  }
  
  /* Customizing the video controls */
  .profile-video-container .profile-vid::-webkit-media-controls-timeline {
    background-color: red;
  }
  
  .profile-video-container .profile-vid::-webkit-media-controls-play-button {
    display: none;
  }
  
  .profile-video-container .profile-vid::-webkit-media-controls {
    display: none;
  }
  .user-details-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0.5rem 0.75rem 0.75rem;
    width: 93%; 
    background-color: white;
  }
  .name-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 0.5rem; 
  }
  
   .name {
    font-family: PP-Nuebit;
    font-weight: 700;
    text-align: left;
    font-size: 1.5rem;
  }
  .mobBodyContainer{
    display: flex;
    flex-direction: column;
    background-color: #e7e7e7;
    width: 100%;
    height: 85vh;
    justify-content: center;
    align-items: center;
    
  }
  .mobredirectionContainer{
   display: flex;
   align-items: center;
   justify-content: flex-start;
   height: 6.7rem;
   width:93.5%;
   padding: 0.875rem 0.75rem;
   margin-top: 4.5rem;
  }
  .mobdirectionLaptopContainer{
    display: flex;
    height: 6rem;
    width:6rem;
    z-index: 20;
    align-items: center;
    justify-content: left;
  }
  .laptopimg{
    height:7.6rem;
  }
  .mobdirection{
    display: flex;
    align-items: center;
    /* padding:0.875rem 0.75rem 0.875rem 0.75rem; */
    height: 3.875rem;
    width:20.75rem;
    border-top: 1px solid #9C9C9C;
    border-right: 1px solid #9C9C9C;
    border-bottom: 1px solid #9C9C9C;
  }
  .mobdirectionText{
    font-family:N27-Bold;
    font-size: 1rem;
    margin: 0;
    text-align: left;
    color: #3D3D3D;
    margin-left: 1rem;
  }
  .mobdirectionTextspan{
    font-family:N27-Bold;
    font-size: 1rem;
    margin: 0;
    text-align: left;
    color: black;
  }
  .box-1 {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
   
  }
  .deflix-contributor-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-right: 0.75rem;
    width: 100%;
  }
  .text {
    font-family: PP-Nuebit;
    font-weight: 400;
    font-size: 1.75rem;
    text-align: left;
    margin: 0;
  }
  .role-box-container{
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-bottom: 1px solid black; 
    height: 1.5rem;
    width: 15rem;
    background-color: #f5f5f5;
    
  }
  .box {
    font-family: N27;
    font-weight: 400;
    font-size: 0.75rem;
   
  }
  .timeline {
    height: 5px; 
    border-top-right-radius:5px;
    border-bottom-right-radius:5px;
    background-color: red; /* The color you want for the progress */
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 100;
  }
  .pause-btn{
    position: absolute;
    top: 31%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    cursor: pointer;
    height: 3rem;
    width: 3rem;
  }
  
}


`, "",{"version":3,"sources":["webpack://./src/components/Pages/Course/coursepagestyle.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,4CAAiD;AACnD;AACA;EACE,uBAAuB;EACvB,4CAA8C;AAChD;AACA;EACE,+BAA+B;EAC/B,4CAAuD;AACzD;AACA;EACE,6BAA6B;EAC7B,4CAAqD;AACvD;;AAEA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,yDAA8D;EAC9D,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,4BAA4B;EAC5B,gCAAgC;;AAElC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;;AAErB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;AAEX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;;AAEjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB,EAAE,wCAAwC;EAC/D,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,UAAU;;;AAGZ;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;;AAE3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;;AAEjB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;EACV,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;;AAEzB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,WAAW;;AAEb;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;;AAEZ;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;;AAEb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;;AAEd;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;;AAEf;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EAEE,gDAAgD;EAChD,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;AACA;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;IACZ,aAAa;EACf;EACA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;;EAE3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA;EACA,UAAU;EACV,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;EACpC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;IAC9B,qBAAqB,EAAE,wCAAwC;IAC/D,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;;EAEA,mCAAmC;EACnC;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,+BAA+B;IAC/B,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;EACvB;;GAEC;IACC,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;GACC,aAAa;GACb,mBAAmB;GACnB,2BAA2B;GAC3B,cAAc;GACd,WAAW;GACX,yBAAyB;GACzB,kBAAkB;EACnB;EACA;IACE,aAAa;IACb,YAAY;IACZ,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;;EAEzB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,cAAc;IACd,YAAY;IACZ,yBAAyB;;EAE3B;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;EAEpB;EACA;IACE,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;IAC9B,qBAAqB,EAAE,wCAAwC;IAC/D,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;AAEF","sourcesContent":["@font-face {\n  font-family: PP-Nuebit;\n  src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n@font-face {\n  font-family: N27;\n  src: url(\"../../../assets/Fonts/N27-Regular.otf\");\n}\n@font-face {\n  font-family: N27-Medium;\n  src: url(\"../../../assets/Fonts/N27-Bold.otf\");\n}\n@font-face {\n  font-family: N27-Regular-Italic;\n  src: url(\"../../../assets/Fonts/N27-RegularItalic.otf\");\n}\n@font-face {\n  font-family: N27-Light-Italic;\n  src: url(\"../../../assets/Fonts/N27-LightItalic.otf\");\n}\n\n@media only screen and (min-width: 900px) {\n.user-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height: 100%;\n  width: 100%;\n  background-image: url('../../../assets/Images/noise_user.png');\n  background-repeat: no-repeat;\n  background-color: transparent;\n  background-size: 23% 82%;\n  background-position-x: center;\n  background-position-y: center;\n}\n.coursenav-bar-container{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height:3rem;\n  padding: 1rem 4rem 1rem 4rem;\n  border-bottom: 1pt solid #c9c9c9;\n \n}\n.coursepage-navigation-container{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 8rem;\n}\n.coursenav-button-container{\n  display: flex;\n  height: 100%;\n  width:8rem;\n  margin-right: 2.5rem;\n}\n\n.course-page-container {\n  display: flex;\n  /* border: 1px solid red; */\n  padding: 4rem 4rem 0 4rem;\n  width:92%;\n}\n\n.course-page-left-grid {\n  max-width: 60%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-right: 2.9rem;\n  margin-top: 1rem;\n}\n.user-box-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width:87%\n}\n\n.course-page-left-grid .box-1 {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 5rem;\n \n}\n.box-1-heading{\n  font-family: N27-Medium;\n  font-weight: 500;\n  font-size: 5.25rem;\n  text-align: left;\n  margin: 0;\n}\n.course-page-left-grid .box-2 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: flex-start; \n}\n\n.team-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 2.5rem;\n}\n.box-2-text{\n  font-family: N27;\n  font-weight: 400;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0;\n}\n.countdown-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 4rem;\n  width:98%;\n\n}\n.course-page-left-grid .progress-bar .progress-text {\n  position: absolute;\n  right: 0.5rem;\n  font-size: 1.25rem;\n  font-family: N27-Medium;\n  color: black;\n}\n.course-page-left-grid .progress-bar .progress-para {\n  position: absolute;\n  right: 40%;\n  font-family: N27;\n  font-size: 1.25rem;\n  color: black;\n}\n\n.course-page-right-grid {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-left: 2.9rem;\n}\n.course-page-right-grid .profile-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 2.5rem;\n  width:35.875rem;\n  \n}\n.profile{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  border: 1px solid rgb(0, 0, 0);\n  margin-bottom: 0.75rem;\n  width: 100%;\n\n}\n\n.course-page-right-grid .profile-container .profile .profile-video-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 34.625rem;\n}\n.course-page-right-grid .profile-container .profile .profile-vid {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.profile-video-container .play-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 5;\n  cursor: pointer;\n}\n\n.timeline {\n  height: 5px; \n  border-top-right-radius:5px;\n  border-bottom-right-radius:5px;\n  background-color: red; /* The color you want for the progress */\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n}\n\n/* Customizing the video controls */\n.profile-video-container .profile-vid::-webkit-media-controls-timeline {\n  background-color: red;\n}\n\n.profile-video-container .profile-vid::-webkit-media-controls-play-button {\n  display: none;\n}\n\n.profile-video-container .profile-vid::-webkit-media-controls {\n  display: none;\n}\n\n\n\n.course-page-right-grid .profile-container .profile .logo {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.user-details-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 1.5rem 0 1.5rem 1.5rem;\n  width: 95%;\n  \n\n}\n\n.course-page-right-grid .profile-container .name-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 1.875rem; \n}\n\n.course-page-right-grid .profile-container .profile .name {\n  font-family: PP-Nuebit;\n  font-weight: 700;\n  text-align: left;\n  font-size: 3.5rem;\n}\n\n.course-page-right-grid .profile-container .box-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  \n}\n.deflix-contributor-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-right: 5rem;\n  width: 100%;\n}\n.course-page-right-grid .profile-container .box-1 .text {\n  font-family: PP-Nuebit;\n  font-weight: 400;\n  font-size: 2.2rem;\n  text-align: left;\n  margin: 0;\n}\n.role-box-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n  border-bottom: 1px solid black; \n  height: 2.375rem;\n  width: 18rem;\n  background-color: #f5f5f5;\n  \n}\n.course-page-right-grid .profile-container .profile .box-1 .box {\n  font-family: N27;\n  font-weight: 400;\n  font-size: 1rem;\n \n}\n.statistic-value {\n    border: 1px solid #c9c9c9;\n    padding: 0.313rem;\n    display: inline-block;\n    margin: 0 0.3rem 1rem 0.31rem;\n    min-width: 1.8rem;\n    height: 1.5rem;\n    text-align: center;\n    font-family: N27-Medium;\n}\n.contribution{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.video-overlay {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.7); \n  width: 87%;\n  height: 89%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 2rem 2.6rem 2rem 2rem;\n}\n\n.overlay-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  \n}\n.overlay-header-container{\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  margin-bottom: 1.2rem;\n}\n.overlay-header{\n  font-family:N27-Regular-Italic;\n  font-size: 2.25rem;\n  text-align: left;\n  color: white;\n  margin: 0;\n}\n.overlay-desciption-container{\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  margin-bottom: 2.5rem;\n}\n.play-btn-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  width: 100%; \n  height:6rem;\n \n}\n.play-btn{\n  cursor: pointer;\n}\n.overlay-text {\n  font-family: N27-Light-Italic; \n  line-height: 160%;\n  font-size: 1rem;\n  text-align: left;\n  color: white;\n  margin: 0;\n}\n.playbutton-description-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 3.75rem;\n  width:100%;\n}\n.playbutton-description{\n  font-family: N27-Light-Italic; \n  line-height: 160%;\n  font-size: 1rem;\n  text-align: center;\n  color: white;\n  margin: 0;\n}\n.task-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  border:1pt solid black;\n  min-height:16.375rem;\n  width:100%;\n  \n}\n.task-header-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  border-bottom: 1pt solid black;\n  height: 3.125rem;\n  width: 94.5%;\n  padding: 0 1.125rem;\n}\n.task-header{\n  font-family: N27-Regular-Italic;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0;\n}\n.task-content-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n  width: 94.5%;\n  padding: 0 1.125rem;\n\n}\n.task-info-container{\n  display: flex;\n  height:6.313rem;\n  justify-content: space-between;\n  align-items:center;\n  width: 100%;\n\n}\n.task-no-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.task-no{\n  font-family:N27-Medium ;\n  font-size: 4rem;\n  text-align: left;\n  color: black;\n  margin: 0;\n}\n.goto-task-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height:3rem;\n  width:11rem;\n  cursor: pointer;\n}\n.course-level-info-outer-container{\n  display: flex;\n  width: 99.5%;\n  padding: 0 0.1rem;\n  justify-content: flex-start;\n  align-items: center;\n}\n.vector-container{\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  height: 100%;\n  width:13.594rem;\n  border-top: 1pt solid #9c9c9c;\n}\n.course-level-info-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 9.375rem;\n  margin: 0 0.938rem;\n  z-index: 100;\n\n}\n.task-course-container{\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.task-course{\n  font-family: N27;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0;\n  min-width: 4rem;\n}\n.task-course-dot{\n  font-family: N27;\n  font-size: 1.25rem;\n  text-align: left;\n  margin: 0 0.2rem 0 0.2rem;\n}\n.task-level-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height:1.5rem;\n  min-width: 4.938rem;\n  background-color: #15B525;\n  margin-left: 0.2rem;\n}\n.task-level{\n  font-family: N27;\n  font-size: 0.8rem;\n  color: white;\n  margin: 0;\n}\n.task-status-info-outer-container{\n  display: flex;\n  width: 99.5%;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 1.25rem;\n}\n\n.task-status-info-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.task-name-time-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.task-play-icon-container{\n  height:1.5rem;\n  width:1.5rem;\n  margin-right: 0.5rem;\n}\n.task-name-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-right: 1.25rem;\n  max-width: 20rem;\n}\n.task-name{\n  font-family: N27-Light-Italic;\n  font-size: 1.25rem;\n  line-height: 150%;\n  color: #3D3D3D;\n  margin: 0;\n  text-align: left;\n}\n.task-time-container{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.task-description-container{\n  display: flex;\n  justify-content:flex-start;\n  align-items:flex-start;\n  padding:0 2rem;\n  margin-top: 0.75rem;\n}\n.task-description{\n  font-family: N27-Light-Italic;\n  font-size: 1rem;\n  line-height: 150%;\n  color: #7B7B7B;\n  text-align: left;\n  margin: 0;\n}\n.task-status-icon-container{\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height:2rem;\n  width:7.5rem;\n  margin: 0.5rem 0;\n}\n.coursepage-navigation-container{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 1.3% 3.6% 1% 35.4%;\n  height: 3rem;\n  width: 92.2%;\n}\n.nav-user-button-container{\n  display: flex;\n  justify-content: space-between;\n  height: 65%;\n  width:16.5rem;\n \n}\n.user-button{\n  height: 2.3rem;\n  width: 8.438rem;\n  border: 0.5pt solid #c6c4c4;\n  background-color: white;\n  padding: 0.3rem 1rem 0.5rem 1rem;\n  font-family:PP-Nuebit ;\n  font-size: 1.35rem;\n  color: black;\n  text-align: center;\n}\n.logout-button{\n  height: 2.3rem;\n  width: 6.438rem;\n  border: 0.5pt solid #c6c4c4;\n  background-color: white;\n  padding: 0.3rem 0.5rem 0.5rem 0.5rem;\n  font-family:PP-Nuebit ;\n  font-size: 1.35rem;\n  color: black;\n  text-align: center;\n  cursor: pointer;\n}\n.course-spin-container {\n  align-items: center;\n  display: flex;\n  height: 50rem;\n  justify-content: center;\n  width: 50rem;\n}\n\n.course-loading {\n  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;\n  animation: sk-scaleout 1.0s infinite ease-in-out;\n  background-color: black;\n  border-radius: 100%;\n  height: 6em;\n  width: 6em;\n}\n.pause-btn{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 5;\n  cursor: pointer;\n  height: 6rem;\n  width: 6rem;\n}\n\n.profile-pause-video-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 34.625rem;\n}\n}\n\n@media only screen and (max-width: 900px) {\n  .mobNavContainer{\n    display: flex;\n    width: 93.5%;\n    height:3.375rem;\n    padding:0.75rem 0.875rem 0.75rem 0.875rem;\n    align-items: center;\n    justify-items: center;\n    background-color: #FFFFFF;\n  }\n  .mobNavBar{\n    display: flex;\n    width: 20.75rem;\n    height: 1.875rem;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .mobnavW3o{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    width:8.5rem;\n    height:1.5rem;\n  }\n  .mobhamburg{\n    height: 1.4rem;\n    width: 1.4rem;\n    margin:0.1rem 0.438rem;\n  }\n  .mobw3onavContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width:6.25rem;\n    font-family: PP-Nuebit;\n    font-size: 1.5rem;\n    margin: 0 0 0.3rem 0.5rem;\n    \n  }\n\n  .profile{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    border: 1px solid rgb(0, 0, 0);\n    margin-bottom: 0.75rem;\n    width: 99.5%;\n  }\n  .profile-video-container {\n    height: 13.5rem;\n  }\n  \n  .video-overlay{\n  width: 93%;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.7); \n  }\n  .overlay-header-container{\n    margin-bottom: 0.5rem;\n  }\n  .overlay-header{\n    font-size: 1.25rem;\n    margin: 0;\n    color: white;\n  }\n  .overlay-desciption-container{\n    margin-bottom: 0.5rem;\n  }\n  .overlay-text {\n    font-size: 0.75rem;\n    margin: 0;\n    color: white;\n  }\n  .play-btn-container{\n    margin-bottom: 0.5rem;\n    width: 100%; \n    height:3rem;\n  }\n  .play-btn {\n    height:3rem;\n    width: 3rem;\n  }\n  .playbutton-description-container{\n    margin-bottom: 0.5rem;\n    width:100%;\n  }\n  .playbutton-description{\n    line-height: 115%;\n    font-size: 0.75rem;\n    margin: 0;\n    color: white;\n  }\n  .profile-vid {\n    width: 100%;\n    height: 13.4rem;\n    object-fit: cover;\n  }\n  \n  .timeline {\n    height: 5px; \n    border-top-right-radius:5px;\n    border-bottom-right-radius:5px;\n    background-color: red; /* The color you want for the progress */\n    position: absolute;\n    bottom: 0;\n    left: 0;\n  }\n  \n  /* Customizing the video controls */\n  .profile-video-container .profile-vid::-webkit-media-controls-timeline {\n    background-color: red;\n  }\n  \n  .profile-video-container .profile-vid::-webkit-media-controls-play-button {\n    display: none;\n  }\n  \n  .profile-video-container .profile-vid::-webkit-media-controls {\n    display: none;\n  }\n  .user-details-container{\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 0.5rem 0.75rem 0.75rem;\n    width: 93%; \n    background-color: white;\n  }\n  .name-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-bottom: 0.5rem; \n  }\n  \n   .name {\n    font-family: PP-Nuebit;\n    font-weight: 700;\n    text-align: left;\n    font-size: 1.5rem;\n  }\n  .mobBodyContainer{\n    display: flex;\n    flex-direction: column;\n    background-color: #e7e7e7;\n    width: 100%;\n    height: 85vh;\n    justify-content: center;\n    align-items: center;\n    \n  }\n  .mobredirectionContainer{\n   display: flex;\n   align-items: center;\n   justify-content: flex-start;\n   height: 6.7rem;\n   width:93.5%;\n   padding: 0.875rem 0.75rem;\n   margin-top: 4.5rem;\n  }\n  .mobdirectionLaptopContainer{\n    display: flex;\n    height: 6rem;\n    width:6rem;\n    z-index: 20;\n    align-items: center;\n    justify-content: left;\n  }\n  .laptopimg{\n    height:7.6rem;\n  }\n  .mobdirection{\n    display: flex;\n    align-items: center;\n    /* padding:0.875rem 0.75rem 0.875rem 0.75rem; */\n    height: 3.875rem;\n    width:20.75rem;\n    border-top: 1px solid #9C9C9C;\n    border-right: 1px solid #9C9C9C;\n    border-bottom: 1px solid #9C9C9C;\n  }\n  .mobdirectionText{\n    font-family:N27-Bold;\n    font-size: 1rem;\n    margin: 0;\n    text-align: left;\n    color: #3D3D3D;\n    margin-left: 1rem;\n  }\n  .mobdirectionTextspan{\n    font-family:N27-Bold;\n    font-size: 1rem;\n    margin: 0;\n    text-align: left;\n    color: black;\n  }\n  .box-1 {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n   \n  }\n  .deflix-contributor-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-right: 0.75rem;\n    width: 100%;\n  }\n  .text {\n    font-family: PP-Nuebit;\n    font-weight: 400;\n    font-size: 1.75rem;\n    text-align: left;\n    margin: 0;\n  }\n  .role-box-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-top: 1px solid black;\n    border-left: 1px solid black;\n    border-bottom: 1px solid black; \n    height: 1.5rem;\n    width: 15rem;\n    background-color: #f5f5f5;\n    \n  }\n  .box {\n    font-family: N27;\n    font-weight: 400;\n    font-size: 0.75rem;\n   \n  }\n  .timeline {\n    height: 5px; \n    border-top-right-radius:5px;\n    border-bottom-right-radius:5px;\n    background-color: red; /* The color you want for the progress */\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    z-index: 100;\n  }\n  .pause-btn{\n    position: absolute;\n    top: 31%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 5;\n    cursor: pointer;\n    height: 3rem;\n    width: 3rem;\n  }\n  \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
